import { useState } from 'react';
import { LotsPage } from './Lots';
import { SerialsPage } from './Serials';

/**
 * Rückverfolgung bündelt die beiden bisher getrennten Menüpunkte Chargen und
 * Seriennummern unter einem Dach - fachlich dasselbe Thema (Rückverfolgbarkeit),
 * nur zwei Sichten.
 */
export function RueckverfolgungPage() {
  const [tab, setTab] = useState<'chargen' | 'serien'>('chargen');
  return (
    <>
      <div className="toolbar" style={{ marginBottom: 12 }}>
        <button className={tab === 'chargen' ? 'primary' : ''} onClick={() => setTab('chargen')}>
          Chargen
        </button>
        <button className={tab === 'serien' ? 'primary' : ''} onClick={() => setTab('serien')}>
          Seriennummern
        </button>
      </div>
      {tab === 'chargen' ? <LotsPage /> : <SerialsPage />}
    </>
  );
}
